
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Salarie from '@/extend/classes/Salarie';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeSalarie' })

export default class storeSalarie extends VuexModule {
  // States
  private reccords: Salarie[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get salarieLoading (): boolean {
    return this.dataLoading;
  }
  private get salarieRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get salarieLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewSalarie() {
    return (): Salarie => { 
      return this.getSalarie(0, true);
    }
  }

  
  public get getSalarie () {
    return (id: number, canCreate = false): Salarie => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Salarie can't be 0")
        return new Salarie();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Salarie();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Salarie.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromSalarie(data.reccords[0] as Salarie);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listSalarie (): Salarie[] {
    return this.reccords;
  }

  public get listConfigSalarie (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mSalarieRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mSalarieClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mSalarieLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mSalarieLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Salarie.fromJson(reccord as Salarie));
    })
    Salarie.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mSalarieConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mSalarieCreated (obj: Salarie): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareSalarie(obj)) {
          api.fromSalarie(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareSalarie(obj)) {
            api.fromSalarie(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mSalarieUpdated (obj: Salarie): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareSalarie(obj)) {
          api.fromSalarie(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mSalarieDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerSalarie (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.salarieRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerSalarie(this.salarieCreated, this.salarieUpdated, this.salarieDeleted);
          this.mSalarieRegistered();
        } else {
          setTimeout(() => resolve(this.registerSalarie(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.salarieLoading && !this.salarieLoaded) {
          this.mSalarieLoading(true);
          return Salarie.list(filter)
            .then((data: ListData) => {
              this.mSalarieLoaded(data);
              this.mSalarieLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredSalarie (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.salarieLoading) {
        this.mSalarieLoading(true);
        return Salarie.list(filter)
          .then((data: ListData) => {
            this.mSalarieLoaded(data);
            this.mSalarieLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createSalarie (obj: Salarie): Promise<Salarie> {
    return new Promise((resolve, reject) => {
      return Salarie.fromJson(obj).createForStoreSalarie()
        .then((reccords) => {
          this.mSalarieCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateSalarie (obj: Salarie): Promise<Salarie> {
    return new Promise((resolve, reject) => {
      return Salarie.fromJson(obj).updateForStoreSalarie()
        .then((reccords) => {
          this.mSalarieUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteSalarie (obj: Salarie): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return Salarie.fromJson(obj).deleteForStoreSalarie()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mSalarieDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private salarieCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mSalarieConfigUpdated(config)
    const obj = objConfig.obj as Salarie;
    this.mSalarieCreated(Salarie.fromJson(obj));
  }

  @Action
  private salarieUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mSalarieConfigUpdated(config)
    const obj = objConfig.obj as Salarie;
    this.mSalarieUpdated(Salarie.fromJson(obj));
  }

  @Action
  private salarieDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Salarie;
    this.mSalarieDeleted(obj.id);
  }
}
